var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.0001,
    height: 28,
    rx: 4,
    fill: "#006FEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0003 16C15.1048 16 16.0003 15.1046 16.0003 14C16.0003 12.8954 15.1048 12 14.0003 12C12.8957 12 12.0003 12.8954 12.0003 14C12.0003 15.1046 12.8957 16 14.0003 16Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45801 14C5.73226 9.94291 9.52256 7 14.0002 7C18.4778 7 22.2681 9.94288 23.5424 14C22.2682 18.0571 18.4778 21 14.0002 21C9.52257 21 5.73228 18.0571 4.45801 14ZM18.0003 14C18.0003 16.2091 16.2094 18 14.0003 18C11.7911 18 10.0003 16.2091 10.0003 14C10.0003 11.7909 11.7911 10 14.0003 10C16.2094 10 18.0003 11.7909 18.0003 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.a8c5bf00dceb97318ef34283861dd870.svg";
export { ForwardRef as ReactComponent };